export default __webpack_public_path__ + "locales/sk/Errors.json?hash=33d5a8c4da523c5f9ed72e055552aff3";